import React from 'react'

function CheckmarkBadgeIcon() {
  return (
    <svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.0008 39.2004C16.0008 39.2004 0.550781 34.2691 0.550781 25.7504V7.05039L16.0014 0.931641L31.4508 7.05039V25.7504C31.4508 34.2691 16.0008 39.2004 16.0008 39.2004Z" fill="#6F6F6F"/>
      <g clipPath="url(#clip0_4246_1668)">
        <path d="M21 18.75H19.75V15C19.75 14.0054 19.3549 13.0516 18.6517 12.3483C17.9484 11.6451 16.9946 11.25 16 11.25C15.0054 11.25 14.0516 11.6451 13.3483 12.3483C12.6451 13.0516 12.25 14.0054 12.25 15V18.75H11C10.6685 18.75 10.3505 18.8817 10.1161 19.1161C9.8817 19.3505 9.75 19.6685 9.75 20V27.5C9.75 27.8315 9.8817 28.1495 10.1161 28.3839C10.3505 28.6183 10.6685 28.75 11 28.75H21C21.3315 28.75 21.6495 28.6183 21.8839 28.3839C22.1183 28.1495 22.25 27.8315 22.25 27.5V20C22.25 19.6685 22.1183 19.3505 21.8839 19.1161C21.6495 18.8817 21.3315 18.75 21 18.75ZM13.5 15C13.5 14.337 13.7634 13.7011 14.2322 13.2322C14.7011 12.7634 15.337 12.5 16 12.5C16.663 12.5 17.2989 12.7634 17.7678 13.2322C18.2366 13.7011 18.5 14.337 18.5 15V18.75H13.5V15ZM21 27.5H11V20H21V27.5Z" fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0_4246_1668">
          <rect width="20" height="20" fill="white" transform="translate(6 10)"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export default CheckmarkBadgeIcon
